// extracted by mini-css-extract-plugin
export var actionButton = "DisplayMessage-module__actionButton___1wI+b";
export var columnAlign = "DisplayMessage-module__columnAlign___v0aDX";
export var container = "DisplayMessage-module__container___X+uah";
export var containerBase = "DisplayMessage-module__containerBase___Hj3AM";
export var containerError = "DisplayMessage-module__containerError___PHVmY";
export var containerWarning = "DisplayMessage-module__containerWarning___8QgMH";
export var description = "DisplayMessage-module__description___tUwnW";
export var iconContainer = "DisplayMessage-module__iconContainer___O4CAC";
export var iconContainerError = "DisplayMessage-module__iconContainerError___dmZP9";
export var iconContainerWarning = "DisplayMessage-module__iconContainerWarning___a4Yi9";
export var link = "DisplayMessage-module__link___l9atm";
export var title = "DisplayMessage-module__title___HCOgD";
export var titleWrapper = "DisplayMessage-module__titleWrapper___oEXRu";